{
  "id": "campaign-098",
  "name": "Misty Knoll",
  "seed": "campaign:98",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "....L__L....",
    ".x...__.,..,",
    "....L__.%,.,",
    ".....__.%%.x",
    ".L..L__.%...",
    ".....__.,...",
    "~i.i.__.i,i.",
    "~..*h__.*...",
    "~.~..__.....",
    ".i~~h__.X.i.",
    "..#..__.....",
    ".....__.....",
    ".i.i.__~i.i.",
    ".....__x~...",
    "X....__~.%..",
    "....i__.%%%.",
    ".........%..",
    "....x......S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 10,
      "y": 3
    },
    {
      "kind": "rabbit",
      "x": 7,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 1
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 13
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 11,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 5
    }
  ],
  "generatorVersion": 3,
  "level": 98,
  "biome": "cemetery",
  "par": {
    "reel": 6666,
    "push": 5684,
    "selfPropelled": 5196,
    "tractor": 4690,
    "zeroTurn": 3355,
    "fairway": 2631
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 5,
      "selfPropelled": 13,
      "tractor": 13,
      "zeroTurn": 9,
      "fairway": 14
    }
  }
}
